export type RouteType = 'collection' | 'createEntity' | 'editEntity' | 'other';

export interface RouteBaseProps {
  /**
   * Page type. Supported values: <br />
   * - `"collection"` <br />
   * - `"createEntity"` <br />
   * - `"editEntity"` <br />
   * - `"other"` <br />
   * @external
   */
  type: RouteType;
}

export interface PatternsReactRouterProps {
  /**
   * Each child element must be a [`PatternsReactRoute`](./?path=%2Fstory%2Fbase-components-pages-router--patternsreactroute) component.
   * @external
   */
  children: React.ReactNode;
}
